import createIcon from '../../createIcon';

/**
 * @component @name Dehaze
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxNlYxOEgyMlYxNkgyWk0yIDExVjEzSDIyVjExSDJaTTIgNlY4SDIyVjZIMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dehaze = createIcon('Dehaze', [
  ['path', { d: 'M2 16V18H22V16H2ZM2 11V13H22V11H2ZM2 6V8H22V6H2Z', key: '18qi3w' }],
]);

export default Dehaze;
